import React, { useMemo, useState, Fragment, useReducer } from 'react';
import * as PropTypes from 'prop-types';

import InfoPopover from '../../../InfoPopover';
import { COLORS } from '../../../../constants/styles';
import { IconButton } from '../../../Button/IconButton';
import { getMyProviderDetails } from '../../../Healthboard/utils/appointment';

function ProviderDetails({ provider, formatMessage, languageTypes }) {
  const [isOpened, toggleTooltip] = useReducer(open => !open, false);
  const [anchor, setAnchor] = useState(null);

  const handleOpenProviderInfo = e => {
    e.stopPropagation();
    setAnchor(e.currentTarget);
    toggleTooltip();
  };

  const list = useMemo(() => {
    return getMyProviderDetails(formatMessage, provider, languageTypes);
  }, [provider, languageTypes]);

  return (
    <Fragment>
      <IconButton
        size={12}
        className="ml2 dib"
        name="info-default"
        fill={COLORS.blueDark}
        onClick={handleOpenProviderInfo}
      />
      <InfoPopover
        list={list}
        isOpen={isOpened}
        anchorEl={anchor}
        onClose={() => toggleTooltip()}
        description={provider.greeting}
      />
    </Fragment>
  );
}

ProviderDetails.propTypes = {
  provider: PropTypes.object,
  formatMessage: PropTypes.func,
  languageTypes: PropTypes.array,
};

export default ProviderDetails;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentMyProviders/ProviderDetails/index.jsx